import type {NodeParameters, Version} from "@cm/graph-v3"

// Single-entry version chain that registers a prior `nodeClass` string as an alias for a renamed
// concrete class with unchanged parameter shape.
export const priorNodeClassChain = <P extends NodeParameters>(priorNodeClass: string): [Version<P, P>] => [{nodeClass: priorNodeClass, toNextVersion: (p) => p}]
